import { render, staticRenderFns } from "./BatchPopup.vue?vue&type=template&id=670122d6&scoped=true"
import script from "./BatchPopup.vue?vue&type=script&lang=js"
export * from "./BatchPopup.vue?vue&type=script&lang=js"
import style0 from "./BatchPopup.vue?vue&type=style&index=0&id=670122d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670122d6",
  null
  
)

export default component.exports